import * as React from 'react';

import { PromotionDescription } from '../../../../components/PromotionDescription';
import { useOfferContext } from '../../../../context';
import { useAuctionContext } from '../../../../context/AuctionContext';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { getIsCpcAuction } from 'shared/utils/auction';
import { isNotSearcher } from 'shared/utils/isNotSearcher';

export const PromotionDescriptionContainer = () => {
  const { config } = useApplicationContext();
  const { offer, vasList, user } = useOfferContext();
  const { currentBet, liquidityPoints } = useAuctionContext();
  const promotionDescription = offer?.promotion?.promotionDescription;
  const isPerformanceVasPilot = !!offer?.promotion?.isPerformanceVasPilot;
  const isBet = !!(currentBet && !liquidityPoints);

  if (!isNotSearcher(user) || !promotionDescription) {
    return null;
  }

  /**
   * @todo: удалить в задаче CD-260866
   */
  const isCpcAuctionEnabled = !!config.get<boolean>('auction.cpcEnabled');
  const isCpcOffer = isCpcAuctionEnabled && getIsCpcAuction(offer);

  if (isCpcOffer) {
    return (
      <PromotionDescription
        promotionDescription={promotionDescription}
        isPerformanceVasPilot={false}
        item={[]}
        isBet={false}
        isCpcOffer={true}
      />
    );
  }

  const isPerformanceVasFlag = !!config.get<boolean>('isPerformanceVASPilot.Enabled');

  if (!isPerformanceVasFlag) {
    return null;
  }

  return (
    <PromotionDescription
      promotionDescription={promotionDescription}
      isPerformanceVasPilot={isPerformanceVasPilot}
      item={vasList}
      isBet={isBet}
      isCpcOffer={isCpcOffer}
    />
  );
};
